define.alias("shared/components/shared/ui/group-avatar", "preview-grid/components/shared/ui/group-avatar");